import { PageRef } from 'providers/page-ref';

export type MealPlanPageParams = {};

export const IMealPlanPage: PageRef<MealPlanPageParams, void> = {
  pageName: 'MealPlanPage',
} as PageRef<MealPlanPageParams, void>;
